import React from 'react';
import { withRouter, NavLink as RouterLink, Link } from 'react-router-dom';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import './index.css';
import logo from '../../../images/OPPTIMISE_logo.png';
import { cookieUtils } from '../../../_helpers/cookieUtils';

class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }

    toggle() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    logout = () => {
        localStorage.clear();
        cookieUtils.deleteCookie('lastAttemptedRoute');
    }

    getUserInfo() {
        return {
            userName: localStorage.getItem('user_name') === 'null' ? '-' : localStorage.getItem('user_name'),
            userType: localStorage.getItem('usertype') || "",
            is_white_labeled_solution: localStorage.getItem('is_white_labeled_solution'),
            seller_image: localStorage.getItem('seller_image'),
            baseLink: localStorage.getItem('baseLink')
        };
    }

    isAdminUser(userType) {
        return ['super_admin', 'seller_admin', 'organisation_admin'].some(type => userType.includes(type));
    }

    getMarginTop(userType) {
        const isSpecialAdmin = userType.includes("organisation_admin") || userType.includes("seller_admin");
        const isSpecialPage = /\/new\/app\/(welcome|questionnaire)\/\d+\/\d+\/\d+\/\d+\/\d+\/(true|false)\/\d+\/assessment/.test(window.location.href);

        if (isSpecialAdmin && isSpecialPage) {
            return window.innerWidth < 500 ? "0px" : "100px";
        }
        return "100px";
    }

    renderLogo(userType, is_white_labeled_solution, seller_image, baseLink) {
        const logoSrc = userType.includes('super_admin') ? logo :
            (is_white_labeled_solution === 'true' && seller_image !== 'null' ? baseLink + seller_image : logo);

        return (
            <NavbarBrand className="text-white logo" href="/app">
                <img src={logoSrc} alt="Logo" />
            </NavbarBrand>
        );
    }

    renderNavItems(userType, isAdmin) {
        return (
            <React.Fragment>
                <NavItem>
                    <RouterLink className="nav-link text-white" to="/app">
                        <i className="fa fa-palette text-green mr-2"></i>
                        <span className="green-hover">Dashboard</span>
                    </RouterLink>
                </NavItem>
                {(userType.includes("organisation_admin") || userType.includes("seller_admin")) && (
                    <NavItem>
                        <RouterLink className="nav-link text-white" to="/new/app/reports/:id">
                            <i className="fa fa-file-alt text-green mr-2"></i>
                            <span className="green-hover">Report</span>
                        </RouterLink>
                    </NavItem>
                )}
                {!(userType.includes('participant') && !isAdmin || userType.length === 0) && (
                    <NavItem>
                        <RouterLink className="nav-link text-white" to="/admin">
                            <i className="fa fa-home text-green mr-2"></i>
                            <span className="green-hover">Admin Area</span>
                        </RouterLink>
                    </NavItem>
                )}
            </React.Fragment>
        );
    }

    render() {
        const { userName, userType, is_white_labeled_solution, seller_image, baseLink } = this.getUserInfo();
        const isAdmin = this.isAdminUser(userType);
        const marginTop = this.getMarginTop(userType);

        return (
            <div className="" style={{ marginTop }}>
                <Navbar expand="md" style={{ position: 'fixed', top: 0, width: '100%', zIndex: 999, background: 'black' }}>
                    {this.renderLogo(userType, is_white_labeled_solution, seller_image, baseLink)}
                    <NavbarToggler onClick={this.toggle} className="ml-auto">
                        <i className="fa fa-bars text-white"></i>
                    </NavbarToggler>
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            {this.renderNavItems(userType, isAdmin)}
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav className="nav-link text-white">
                                    <i className="fa fa-user text-green mr-2"></i>
                                    <span className="dropdown-text text-capitalize">{userName}</span>
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <Link className="text-dark p-0" to="/new/app/user-details">
                                        <DropdownItem>
                                            <span className="green-hover">
                                                <i className="fas fa-user-edit text-green mr-2"></i>
                                                View/Edit Profile
                                            </span>
                                        </DropdownItem>
                                    </Link>
                                    <Link className="text-dark p-0" to="/change-admin-password">
                                        <DropdownItem>
                                            <span className="green-hover">
                                                <i className="fa fa-key text-green mr-2"></i>
                                                Change Password
                                            </span>
                                        </DropdownItem>
                                    </Link>
                                    <DropdownItem divider />
                                    <RouterLink className="nav-link text-dark p-0" to="/login">
                                        <DropdownItem>
                                            <span
                                                onClick={this.logout}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.logout();
                                                    }
                                                }}
                                                className="green-hover"
                                                tabIndex={0}
                                                role="button"
                                            >
                                                <i className="fa fa-sign-out-alt text-green mr-2"></i>
                                                Logout
                                            </span>
                                        </DropdownItem>
                                    </RouterLink>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}

export default withRouter(NavBar);


// WEBPACK FOOTER //
// ./src/_components/common/Navbar/index.jsx